import React from 'react';
import './Integrations.css';

function Integrations() {
  return (
    <div className="integrations-container">
      <section className="integrations-header">
        <h1>Integrations</h1>
        <p>Connect ThreadApp with your favorite tools to streamline your social media management.</p>
      </section>
      <section className="integrations-list">
        <div className="integration-item">
          <img src = "/image/threads.png"  alt="Threads" />
          <h3>Threads</h3>
          <p>Threads
          Start conversations and build a close-knit community with text, image, video, and carousel posts.</p>
        </div>
        <div className="integration-item">
          <img src="/image/facebook.svg" alt="Facebook" />
          <h3>Facebook</h3>
          <p>Get discovered and increase exposure to your content with sponsored posts.</p>
        </div>
        <div className="integration-item">
          <img src="/image/x.svg" alt="X/Twitter" />
          <h3>X/Twitter</h3>
          <p>Keep your brand sentiment high by staying on top of every reply and DM.</p>
        </div>
        {/* Add more integration items as needed */}
      </section>
    </div>
  );
}

export default Integrations;